import { jsx as o } from "../../_virtual/jsx-runtime.mjs";
import { w as m } from "../../packages/utils/dist/useIntersectionObserver-1ee6520e.mjs";
import "react";
import "../../packages/basic/dist/es/components/ReoIcon/ReoIcon.mjs";
import "../../packages/basic/dist/es/components/ReoBalloon/ReoBalloon.mjs";
import "../../packages/basic/dist/es/components/ReoButton/index.mjs";
import "../../packages/basic/dist/es/components/ReoCheckbox/index.mjs";
import i from "../../packages/basic/dist/es/components/ReoLink/ReoLink.mjs";
import "../../packages/basic/dist/es/_virtual/jsx-runtime.mjs";
import "../../packages/basic/dist/es/depend/classnames/index.mjs";
import "../../packages/basic/dist/es/assets/css/globalTheme.mjs";
import "../../packages/basic/dist/es/assets/css/themes/template/templateMap.mjs";
import "../../packages/basic/dist/es/components/ReoTabs/ReoTabTree.mjs";
import "../../packages/basic/dist/es/components/ReoInput/index.mjs";
import "../../packages/basic/dist/es/components/ReoSelect/ReoSelect.mjs";
import "../../packages/basic/dist/es/components/ReoPopup/ReoPopup.mjs";
import "../../packages/basic/dist/es/components/ReoUpload/UploadList.mjs";
import "../../packages/basic/dist/es/components/ReoUpload/const.mjs";
import "../../packages/basic/dist/es/depend/rc-upload/es/Upload.mjs";
import "../../packages/basic/dist/es/components/ReoUpload/DraggedUploadList.mjs";
import "../../packages/basic/dist/es/components/ReoAccordion/AccordionItem.mjs";
import "../../packages/basic/dist/es/depend/swiper/swiper-react.mjs";
import "../../packages/basic/dist/es/Basic/LoadingBar/LoadingBar.mjs";
import "../../packages/basic/dist/es/components/ReoMessage/ReoMessage.mjs";
import "../../packages/basic/dist/es/components/ReoForm/index.mjs";
import { useOmitProps as e } from "../../hook/useOmitProps.mjs";
const p = (r) => {
  const t = e(r, ["target", "noreferrer", "nofollow", "href", "text"]);
  return /* @__PURE__ */ o(
    i,
    {
      target: r.target,
      rel: `${r.noreferrer ? "noreferrer" : ""} ${r.nofollow ? "nofollow" : ""}`,
      href: r.href ?? "",
      ...t,
      children: r.text
    }
  );
}, C = m(p, {});
export {
  C as default
};
//# sourceMappingURL=Link.mjs.map
